import { c as _c } from "react/compiler-runtime";
import { useAuth0, User } from "@auth0/auth0-react";
import { useState } from "react";
import { TaxUnit } from "../../../../models";
import { useTaxUnits } from "../../../../_queries";
import { EffektButton } from "../../../shared/components/EffektButton/EffektButton";
import { Spinner } from "../../../shared/components/Spinner/Spinner";
import { TaxUnitList } from "../../shared/lists/taxUnitList/TaxUnitList";
import { TaxUnitMobileList } from "../../shared/lists/taxUnitList/TaxUnitMobileList";
import { TaxUnitCreateModal } from "../../shared/TaxUnitModal/TaxUnitCreateModal";
import styles from "./TaxUnitsTab.module.scss";
interface TaxUnitsTabProps {
  title?: string;
  createButtonLabel?: string;
  emptyStateDescription?: string;
  emptyStateLinkLabel?: string;
  numberOfDonationsLabel: string;
  sumDonationsLabel: string;
  sumTaxDeductionsLabel: string;
  sumTaxBenefitLabel: string;
}
export const TaxUnitsTab: React.FC<TaxUnitsTabProps> = t0 => {
  const $ = _c(19);
  const {
    title: t1,
    createButtonLabel: t2,
    emptyStateDescription: t3,
    emptyStateLinkLabel: t4,
    numberOfDonationsLabel,
    sumDonationsLabel,
    sumTaxDeductionsLabel,
    sumTaxBenefitLabel
  } = t0;
  const title = t1 === undefined ? "Dine skatteenheter" : t1;
  const createButtonLabel = t2 === undefined ? "Opprett ny skatteenhet" : t2;
  const emptyStateDescription = t3 === undefined ? "Vi har ikke registrert noen skatteenheter p\xE5 deg. For \xE5 f\xE5 skattefradrag p\xE5 donasjoner m\xE5 du registrere ditt personnummer, eller organisasjonsnummer hvis du donerer fra en skattepliktig bedrift. Du kan registrere flere skatteenheter p\xE5 samme bruker." : t3;
  const emptyStateLinkLabel = t4 === undefined ? "Opprett din f\xF8rste skatteenhet her." : t4;
  const {
    getAccessTokenSilently,
    user
  } = useAuth0();
  const {
    loading,
    data,
    error
  } = useTaxUnits(user as User, getAccessTokenSilently);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  let t5;
  if ($[0] !== title) {
    t5 = <h4 className={styles.header}>{title}</h4>;
    $[0] = title;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== createButtonLabel || $[3] !== data || $[4] !== emptyStateDescription || $[5] !== emptyStateLinkLabel || $[6] !== error || $[7] !== loading || $[8] !== numberOfDonationsLabel || $[9] !== sumDonationsLabel || $[10] !== sumTaxBenefitLabel || $[11] !== sumTaxDeductionsLabel) {
    t6 = !loading && !error && data ? data.filter(_temp).length > 0 ? <><div className={styles.desktopList}>{data.filter(_temp2).map(taxUnit_0 => <TaxUnitList key={taxUnit_0.id} taxUnits={[taxUnit_0]} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} sumTaxBenefitLabel={sumTaxBenefitLabel} />)}</div><div className={styles.mobileList}><TaxUnitMobileList taxUnits={data.filter(_temp3)} numberOfDonationsLabel={numberOfDonationsLabel} sumDonationsLabel={sumDonationsLabel} sumTaxDeductionsLabel={sumTaxDeductionsLabel} /></div><div className={styles.buttonContainer}><EffektButton onClick={() => setCreateModalOpen(true)}>{createButtonLabel}</EffektButton></div></> : <div className={styles.noTaxUnits}><p className={styles.noTaxUnitsText}>{emptyStateDescription}</p><a onClick={() => setCreateModalOpen(true)} className={styles.noTaxUnitsLink}>{emptyStateLinkLabel}</a></div> : <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}><Spinner /></div>;
    $[2] = createButtonLabel;
    $[3] = data;
    $[4] = emptyStateDescription;
    $[5] = emptyStateLinkLabel;
    $[6] = error;
    $[7] = loading;
    $[8] = numberOfDonationsLabel;
    $[9] = sumDonationsLabel;
    $[10] = sumTaxBenefitLabel;
    $[11] = sumTaxDeductionsLabel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== createModalOpen) {
    t7 = createModalOpen && <TaxUnitCreateModal open={createModalOpen} onSuccess={unit => {
      setCreateModalOpen(false);
    }} onFailure={_temp4} onClose={() => {
      setCreateModalOpen(false);
    }} />;
    $[13] = createModalOpen;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className={styles.container}>{t5}{t6}{t7}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
function _temp(taxUnit_2) {
  return taxUnit_2.archived === null;
}
function _temp2(taxUnit) {
  return taxUnit.archived === null;
}
function _temp3(taxUnit_1) {
  return taxUnit_1.archived === null;
}
function _temp4() {}